<template>
  <div v-loading="loading">
    <div class="tab">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <el-form ref="form" :model="form" label-width="160px" size="mini">
            <el-row>
              <el-col :span="8">
                <el-form-item
                  v-if="teacherTution === '1'"
                  prop="batchNameOrClassCode"
                  label="开课批次/班级编码："
                >
                  <el-input
                    size="small"
                    v-model="form.batchNameOrClassCode"
                  ></el-input>
                </el-form-item>
                <el-form-item v-else label="课程名称：">
                  <el-input size="small" v-model="form.courseName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="fullName" label="姓名：">
                  <el-input size="small" v-model="form.fullName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  v-if="teacherTution === '1'"
                  prop="phone"
                  label="手机号："
                >
                  <el-input size="small" v-model="form.phone"></el-input>
                </el-form-item>
                <el-form-item v-else prop="uname" label="用户名：">
                  <el-input size="small" v-model="form.uname"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item prop="assessEndTime" label="课程考核结束时间：">
                  <el-date-picker
                    size="small"
                    v-model="form.assessEndTime"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    range-separator="至"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :unlink-panels="true"
                    style="width: 100%"
                    class="datetime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="finalScore" label="成绩：">
                  <div class="score_input">
                    <el-input
                      size="small"
                      v-model="form.finalScoreStartVal"
                      placeholder="分数"
                      class="minscore_input"
                      :class="{
                        border_focus: borderFocus,
                        border_hover: borderHover,
                      }"
                      @focus="focusBorder"
                      @blur="blurBorder"
                      @mouseover.native="overBorder"
                      @mouseleave.native="leaveBorder"
                    ></el-input>
                    <span class="score_input_range">至</span>
                    <el-input
                      size="small"
                      v-model="form.finalScoreEndVal"
                      placeholder="分数"
                      class="maxscore_input"
                      :class="{
                        border_focus: borderFocus,
                        border_hover: borderHover,
                      }"
                      @focus="focusBorder"
                      @blur="blurBorder"
                      @mouseover.native="overBorder"
                      @mouseleave.native="leaveBorder"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="scoreStatus" label="总评：">
                  <el-select
                    ref="applyTypeSelect"
                    v-model="form.scoreStatus"
                    placeholder="-不限-"
                    size="small"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in overallList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="btn" style="text-align: center">
              <el-row>
                <el-button type="primary" size="mini" @click="search"
                  >确定</el-button
                >
                <el-button size="mini" @click="toggle">收起</el-button>
                <el-button size="mini" @click="delAll">清空</el-button>
              </el-row>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="control">
        <el-button type="primary" @click="toggle">筛选</el-button>
        <el-button type="primary" @click="exportScore" v-if="roleType != 60">导出筛选结果</el-button>
        <el-button type="primary" @click="importScoreDialogVisible = true" v-if="roleType != 60">
          导入考核分
        </el-button>
        <el-button type="primary" @click="importAttendanceDialogVisible = true" v-if="roleType != 60&& userType === '1'">
          导入课堂考勤
        </el-button>
        <el-button type="primary" @click="showTipsDialog" v-if="roleType != 60">督学提醒</el-button>
      </div>
      <el-dialog
        title="督学提醒："
        :visible.sync="tipsDialogVisible"
        width="560px"
        @close="closeTipsDialog"
        class="tips_dialog"
      >
        <el-form ref="tipsForm" :model="tipsForm" :rules="tipsFormRules">
          <el-form-item prop="tipsTextarea">
            <el-input
              type="textarea"
              :rows="6"
              v-model="tipsForm.tipsTextarea"
              @input="tipsTextareaChange"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="radio">
            <div v-for="(item, index) in tipsFormRadioList" :key="index">
              <el-radio
                v-model="tipsForm.radio"
                :label="item"
                @change="tipsFormRadioChange"
              ></el-radio>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="sendTips">发送</el-button>
          <el-button type="info" @click="tipsDialogVisible = false"
            >取消</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="导入考核分"
        :visible.sync="importScoreDialogVisible"
        width="600px"
        destroy-on-close
      >
        <span style="color: #d9001b"
          >注：考核分导入只针对主观分类考核进行导入，包含：政治思想品德、作业完成情况、互动完成情况、三种考核分进行批量导入，其它考核分数由系统自动生成</span
        >
        <span
          slot="footer"
          class="dialog-footer"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            @click="downloadTemplate('score')"
            style="margin-right: 50px; width: 126px"
            >下载模板</el-button
          >
          <el-upload
            class="upload-demo"
            :action="url + '/zkfz/zkolCourseScore/importCourseCheckScoreWithAlbum'"
            :show-file-list="false"
            :on-success="uploadImportCourseCheckScore"
            :on-error="failUpload"
            style="position: relative"
          >
            <el-button type="primary">选择上传文件</el-button>
            <div
              slot="tip"
              class="el-upload__tip"
              style="position: absolute; bottom: -16px; left: 14px"
            >
              只能上传excel文件
            </div>
          </el-upload>
        </span>
      </el-dialog>
      <el-dialog
        title="导入课堂考勤"
        :visible.sync="importAttendanceDialogVisible"
        width="600px"
        destroy-on-close
      >
        <span style="color: #d9001b"
          >注：课堂考勤记录导入，包含：院校、学生名称、学号、课程名称、集中授课安排、课时、签到情况、签退情况、签到形式、有效学时时长</span
        >
        <span
          slot="footer"
          class="dialog-footer"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            @click="downloadTemplate('attendance')"
            style="margin-right: 50px; width: 126px"
            >下载模板</el-button
          >
          <el-upload
            class="upload-demo"
            :action="url + '/zkfz/zkolCourseScore/importClassAttendance'"
            :show-file-list="false"
            :on-success="uploadClassAttendance"
            :on-error="failUpload"
            style="position: relative"
          >
            <el-button type="primary">选择上传文件</el-button>
            <div
              slot="tip"
              class="el-upload__tip"
              style="position: absolute; bottom: -16px; left: 14px"
            >
              只能上传excel文件
            </div>
          </el-upload>
        </span>
      </el-dialog>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      class="score_table"
      @sort-change="sortChange"
      @cell-mouse-enter="cellMouseeEnter"
      @cell-mouse-leave="cellMouseLeave"
    >
      <el-table-column align="center" width="50">
        <template slot="header">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
          />
        </template>
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.checked"
            @change="handleCheckOneChange"
          />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        width="50"
        label="序号"
        prop="rowNum"
      ></el-table-column>
      <!-- <el-table-column
        align="center"
        label="开课批次/班级编码"
        prop="classCode"
      >
        <template slot-scope="scope">
          {{ scope.row.batchName }} / {{ scope.row.classCode }}
        </template>
      </el-table-column> -->
      <el-table-column
        v-if="teacherTution !== '1'"
        align="center"
        prop="courseName"
        label="课程名称"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        v-if="teacherTution !== '1'"
        align="center"
        prop="uname"
        label="用户名"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="fullName"
        label="姓名"
        sortable="custom"
      >
        <template slot-scope="scope">
          <div
            @click="
              showGeneralTest(scope.row.fullName, scope.row.courseScoreId)
            "
          >
            {{ scope.row.fullName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="teacherTution === '1'"
        align="center"
        prop="phone"
        label="手机号（账号）"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="attendanceFinishInfo"
        label="学习时长"
      >
        <template slot-scope="scope">
          <div
            style="color: rgba(22, 163, 137, 0.996078431372549)"
            @click="
              showLearningOutcomeDetail(
                scope.row.fullName,
                scope.row.courseName,
                scope.row.courseScoreId,
                scope.row.uid,
                scope.row.courseId,
                0,
                null,
                scope.row.batchId
              )
            "
          >
            {{ scope.row.attendanceFinishInfo }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="exerciseFinishInfo"
        label="知识点练习"
      >
        <template slot-scope="scope">
          <div
            style="color: rgba(22, 163, 137, 0.996078431372549)"
            @click="
              showLearningOutcomeDetail(
                scope.row.fullName,
                scope.row.courseName,
                scope.row.courseScoreId,
                scope.row.uid,
                scope.row.courseId,
                1,
                null,
                scope.row.batchId
              )
            "
          >
            {{ scope.row.exerciseFinishInfo }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="testFinishInfo"
        label="阶段作业成绩"
      >
        <template slot-scope="scope">
          <div
            style="color: rgba(22, 163, 137, 0.996078431372549)"
            @click="
              showLearningOutcomeDetail(
                scope.row.fullName,
                scope.row.courseName,
                scope.row.courseScoreId,
                scope.row.uid,
                scope.row.courseId,
                2,
                null,
                scope.row.batchId
              )
            "
          >
            {{ scope.row.testFinishInfo }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="generalTestScore"
        label="综合测评成绩"
      >
        <template slot-scope="scope">
          <!-- <div
            style="color: rgba(22, 163, 137, 0.996078431372549)"
            @click="
              showLearningOutcomeDetail(
                scope.row.fullName,
                scope.row.courseName,
                scope.row.courseScoreId,
                scope.row.uid,
                scope.row.courseId,
                3,
                null,
                scope.row.batchId
              )
            "
          >
            {{ scope.row.generalTestScore }}
          </div> -->
          <div style="color: rgba(22, 163, 137, 0.996078431372549)">
            {{ scope.row.generalTestScore }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="moralScore" label="诚信表现">
        <template slot-scope="scope">
          <!-- <div
            style="color: rgba(22, 163, 137, 0.996078431372549)"
            @click="
              showLearningOutcomeDetail(
                scope.row.fullName,
                scope.row.courseName,
                scope.row.courseScoreId,
                scope.row.uid,
                scope.row.courseId,
                4,
                null,
                scope.row.batchId
              )
            "
          >
            {{ scope.row.moralScore }}
          </div> -->
          <div style="color: rgba(22, 163, 137, 0.996078431372549)">
            {{ scope.row.moralScore }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="classAttendanceFinishInfo"
        label="课堂出勤情况"
      >
        <template slot-scope="scope">
          <div
            style="color: rgba(22, 163, 137, 0.996078431372549)"
            @click="
              showLearningOutcomeDetail(
                scope.row.fullName,
                scope.row.courseName,
                scope.row.courseScoreId,
                scope.row.uid,
                scope.row.courseId,
                3,
                null,
                scope.row.batchId
              )
            "
          >
            {{ scope.row.classAttendanceFinishInfo }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="homeworkScore" label="作业完成情况">
        <template slot-scope="scope">
          <!-- <div
            style="color: rgba(22, 163, 137, 0.996078431372549)"
            @click="
              showLearningOutcomeDetail(
                scope.row.fullName,
                scope.row.courseName,
                scope.row.courseScoreId,
                scope.row.uid,
                scope.row.courseId,
                6,
                null,
                scope.row.batchId
              )
            "
          >
            {{ scope.row.homeworkScore }}
          </div> -->
          <div style="color: rgba(22, 163, 137, 0.996078431372549)">
            {{ scope.row.homeworkScore }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="interactScore" label="互动完成情况">
        <template slot-scope="scope">
          <!-- <div
            style="color: rgba(22, 163, 137, 0.996078431372549)"
            @click="
              showLearningOutcomeDetail(
                scope.row.fullName,
                scope.row.courseName,
                scope.row.courseScoreId,
                scope.row.uid,
                scope.row.courseId,
                7,
                null,
                scope.row.batchId
              )
            "
          >
            {{ scope.row.interactScore }}
          </div> -->
          <div style="color: rgba(22, 163, 137, 0.996078431372549)">
            {{ scope.row.interactScore }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="finalScore"
        label="成绩"
        width="80"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="scoreStatus"
        label="总评"
        width="80"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.orderOver === false" class="indicatorIncomplete">
            未到考核时间
          </div>
          <div
            v-if="scope.row.orderOver === true"
            :class="
              scope.row.scoreStatus === '指标不全' ? 'indicatorIncomplete' : ''
            "
          >
            {{ scope.row.scoreStatus }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="assessEndTime"
        label="课程考核结束时间"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
    <el-dialog
      :title="generalTestFullName + '综合考核情况'"
      :visible.sync="generalTestDialogVisible"
      width="670px"
      @close="closeGeneralTest"
    >
      <el-form
        ref="generalTestForm"
        :model="generalTestForm"
        label-width="120px"
      >
        <el-row type="flex">
          <el-col>
            <el-form-item label="成绩 : ">
              <el-input
                v-model="generalTestForm.finalScore"
                :disabled="roleType===60?true:false"
                size="small"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="总评 : ">
              <el-input
                v-model="generalTestForm.scoreStatus"
                size="small"
                :disabled="roleType===60?true:false"
                :class="isIndicatorIncomplete ? 'indicatorIncomplete' : ''"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col>
            <el-form-item label="学习时长 : ">
              <el-input
                v-model="generalTestForm.attendanceFinishInfo"
                :disabled="roleType===60?true:false"
                size="small"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="练习完成情况 : ">
              <el-input
                v-model="generalTestForm.exerciseFinishInfo"
                :disabled="roleType===60?true:false"
                size="small"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col>
            <el-form-item label="测验完成情况 : ">
              <el-input
                v-model="generalTestForm.testFinishInfo"
                :disabled="roleType===60?true:false"
                size="small"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="综合测评 : ">
              <el-input
                v-model="generalTestForm.generalTestScore"
                :disabled="roleType===60?true:false"
                size="small"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col>
            <el-form-item label="政治思想品德 : ">
              <el-input
                v-model="generalTestForm.moralScore"
                size="small"
                placeholder="-请输入考试分数-"
                :disabled="roleType===60?true:false"
                class="generalScoreTips"
                style="width: 180px"
                @blur="
                  saveCourseScore(
                    generalTestForm.courseScoreId,
                    'moralScore',
                    generalTestForm.moralScore
                  )
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="课堂出勤情况 : ">
              <el-input
                v-model="generalTestForm.classAttendanceFinishInfo"
                size="small"
                placeholder="请输入出勤情况"
                :disabled="roleType===60?true:false"
                class="generalScoreTips"
                style="width: 180px"
                @focus="
                  showLearningOutcomeDetail(
                    generalTestForm.fullName,
                    generalTestForm.courseName,
                    generalTestForm.courseScoreId,
                    generalTestForm.uid,
                    generalTestForm.courseId,
                    3,
                    'isGeneral',
                    generalTestForm.batchId
                  )
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col>
            <el-form-item label="作业完成情况 : ">
              <el-input
                v-model="generalTestForm.homeworkScore"
                size="small"
                placeholder="-请输入考试分数-"
                :disabled="roleType===60?true:false"
                class="generalScoreTips"
                style="width: 180px"
                @blur="
                  saveCourseScore(
                    generalTestForm.courseScoreId,
                    'homeworkScore',
                    generalTestForm.homeworkScore
                  )
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="互动完成情况 : ">
              <el-input
                v-model="generalTestForm.interactScore"
                size="small"
                placeholder="-请输入考试分数-"
                :disabled="roleType===60?true:false"
                class="generalScoreTips"
                style="width: 180px"
                @blur="
                  saveCourseScore(
                    generalTestForm.courseScoreId,
                    'interactScore',
                    generalTestForm.interactScore
                  )
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="generalTestDialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <LearningOutcomeDetail
      v-if="learningOutcomeDetailVisible"
      :curUserInfo="curUserInfo"
      @prevIndex="prevIndex"
      @nextIndex="nextIndex"
      @closeLearningOutcomeDetail="closeLearningOutcomeDetail"
    />
  </div>
</template>

<script>
import * as api from '@/api/learningOutcome/learningOutcome'
import * as api2 from '@/api/courseware/checkCourseware'
import LearningOutcomeDetail from './LearningOutcomeDetail/index.vue'
export default {
  components: {
    LearningOutcomeDetail,
  },
  props: ['teacherTution'],
  data() {
    return {
      uid: '',
      courseId: this.$route.query.courseId || '',
      orderAlbumId: this.$route.query.id || '', //班级ID
      batchId: this.$route.query.batchId || '', //批次号ID
      courseScoreId: '',
      activeName: 'first',
      activeNames: [],
      form: {
        batchNameOrClassCode: '',
        fullName: '',
        phone: '',
        assessEndTime: '',
        assessEndTimeStartVal: null,
        assessEndTimeEndVal: null,
        finalScoreStartVal: '',
        finalScoreEndVal: '',
        scoreStatus: '',
        uname: '',
        courseName: '',
      },

      borderFocus: false,
      borderHover: false,
      loading: false,
      overallList: [
        { label: '优秀', value: '1' },
        { label: '良好', value: '2' },
        { label: '合格', value: '3' },
        { label: '不及格', value: '4' },
        // { label: '指标不全', value: '5' },
        { label: '未到考核时间', value: '6' },
      ],

      checkAll: false,
      isIndeterminate: false,
      tableData: [],

      importScoreDialogVisible: false,
      importAttendanceDialogVisible: false,

      tipsDialogVisible: false,
      tipsForm: {
        tipsTextarea: '',
        radio: '',
      },
      tipsFormRadioList: ['备选1', '备选2'],
      tipsFormRules: {
        tipsTextarea: [
          { required: true, message: '请输入提醒语', trriger: 'blur' },
        ],
      },

      learningOutcomeDetailVisible: false,
      curUserInfo: {},

      generalTestFullName: '',
      generalTestDialogVisible: false,
      generalTestForm: {},
      isIndicatorIncomplete: false,

      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      sortObj: { orderByField: '', orderBy: '' },
      roleType:0, // 角色类型 为60需要隐藏的功能
      userType:null // 用户类型
    }
  },
  created() {
    this.initForm = { ...this.form }
    // this.getCourseScore({ page: '1', pageSize: '20' })
    this.getFindUserByUid()
    this.getUserByUid();
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.enterQuery)
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  methods: {
    //获取学习结果列表（分页）
    getCourseScore({ page, pageSize, uid, courseId }) {
      console.log(' courseId:', this.courseId)
      this.loading = true
      let courseTeacherId = ''
      if (this.teacherTution === '1') courseTeacherId = this.getUId
      const {
        batchNameOrClassCode,
        fullName,
        phone,
        assessEndTime,
        finalScoreStartVal,
        finalScoreEndVal,
        scoreStatus,
        uname,
        courseName,
      } = this.form
      let assessEndTimeStartVal =
        assessEndTime && assessEndTime.length && assessEndTime[0]
      let assessEndTimeEndVal =
        assessEndTime && assessEndTime.length && assessEndTime[1]
      this.courseId = courseId ? courseId : this.$route.query.courseId
      this.uid = uid || ''
      api
        .getPageByWithAlbum({
          page,
          pageSize,
          ...this.sortObj,
          courseId: this.courseId,
          orderAlbumId: this.orderAlbumId,
          batchId: this.batchId,
          courseTeacherId,
          batchNameOrClassCode,
          fullName,
          courseName,
          uname,
          phone,
          finalScoreStartVal,
          finalScoreEndVal,
          scoreStatus,
          assessEndTimeStartVal,
          assessEndTimeEndVal,
          uid: this.uid,
        })
        .then(({ data }) => {
          if (data.code === 100000) {
            const dataObj = data.data.page
            this.total = dataObj.total
            this.tableData = dataObj.list.map((item) => {
              return { ...item, checked: false }
            })
          } else {
            this.$message.error(data.msg)
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    //搜索的折叠面板
    toggle() {
      if (this.activeNames.length > 0) {
        this.activeNames = []
        window.removeEventListener('keyup', this.enterQuery)
      } else {
        this.activeNames = ['1']
        window.addEventListener('keyup', this.enterQuery)
      }
    },
    enterQuery(e) {
      if (e.key === 'Enter') {
        this.search()
      }
    },
    visibleChange(e) {
      if (!e) {
        this.$refs.applyTypeSelect.blur()
      }
    },
    //清空搜索内容
    delAll() {
      this.$refs.form.resetFields()
      this.form = { ...this.initForm }

      this.getCourseScore({ page: 1, pageSize: 20 })
    },
    //搜索
    search() {
      this.getCourseScore({ page: '1', pageSize: '20', uid:this.uid , courseId:this.courseId })
    },
    //导出excel
    exportScore() {
      let courseTeacherId = ''
      if (this.teacherTution === '1') courseTeacherId = this.getUId
      const {
        batchNameOrClassCode,
        fullName,
        uname,
        phone,
        assessEndTime,
        finalScoreStartVal,
        finalScoreEndVal,
        scoreStatus,
        courseName,
      } = this.form
      const [assessEndTimeStartVal, assessEndTimeEndVal] = assessEndTime

      let api = ''
      if (this.orderAlbumId) {
        api = 'exportExcelByOrderAlbumId'
      } else {
        api = 'exportExcel'
      }

      window.open(
        `${this.url}/zkfz/zkolCourseScore/${api}?orderAlbumId=${
          this.orderAlbumId
        }&courseId=${this.courseId || ''}&batchId=${
          this.batchId || ''
        }&courseTeacherId=${courseTeacherId}&batchNameOrClassCode=${batchNameOrClassCode}&courseName=${courseName}&fullName=${fullName}&uname=${uname}&phone=${phone}&assessEndTimeStartVal=${
          assessEndTimeStartVal || ''
        }&assessEndTimeEndVal=${
          assessEndTimeEndVal || ''
        }&finalScoreStartVal=${finalScoreStartVal}&finalScoreEndVal=${finalScoreEndVal}&scoreStatus=${scoreStatus}&uid=${
          this.uid ? this.uid : ''
        }`
      )
    },
    //排序
    sortChange({ column, prop, order }) {
      this.sortObj.orderByField = prop
      if (order && order.indexOf('desc') !== -1) {
        this.sortObj.orderBy = 'desc'
      } else {
        this.sortObj.orderBy = 'asc'
      }
      this.getCourseScore({ ...this.pageObj })
    },
    cellMouseeEnter(row, column, cell, event) {
      const colName = [
        '姓名',
        '学习时长',
        '知识点练习',
        '阶段作业成绩',
        '综合测评成绩',
        '诚信表现',
        '课堂出勤情况',
        '作业完成情况',
        '互动完成情况',
      ]
      if (!colName.includes(column.label)) return
      if (cell.firstChild.firstChild.tagName === 'DIV') {
        cell.firstChild.firstChild.style.color = 'rgb(64, 158, 255)'
        cell.firstChild.firstChild.style.cursor = 'pointer'
      }
    },
    cellMouseLeave(row, column, cell, event) {
      const colName = [
        '学习时长',
        '知识点练习',
        '阶段作业成绩',
        '综合测评成绩',
        '诚信表现',
        '课堂出勤情况',
        '作业完成情况',
        '互动完成情况',
      ]
      if (colName.includes(column.label)) {
        cell.firstChild.firstChild.style.color =
          'rgba(22, 163, 137, 0.996078431372549)'
      } else if (column.label === '姓名') {
        cell.firstChild.firstChild.removeAttribute('style')
      }
    },
    //下载模板
    downloadTemplate(type) {
      let courseTeacherId = ''
      if (this.teacherTution === '1') courseTeacherId = this.getUId
      const {
        batchNameOrClassCode,
        fullName,
        phone,
        assessEndTime,
        finalScoreStartVal,
        finalScoreEndVal,
        scoreStatus,
        uname,
        courseName,
      } = this.form
      let assessEndTimeStartVal =
        assessEndTime && assessEndTime.length && assessEndTime[0]
      let assessEndTimeEndVal =
        assessEndTime && assessEndTime.length && assessEndTime[1]

      let condition = `?courseId=${this.courseId || ''}&orderAlbumId=${
        this.orderAlbumId
      }&batchId=${
        this.batchId
      }&courseTeacherId=${courseTeacherId}&batchNameOrClassCode=${batchNameOrClassCode}&fullName=${fullName}&courseName=${courseName}&uname=${uname}&phone=${phone}&finalScoreStartVal=${finalScoreStartVal}&finalScoreEndVal=${finalScoreEndVal}&scoreStatus=${scoreStatus}&assessEndTimeStartVal=${assessEndTimeStartVal}&assessEndTimeEndVal=${assessEndTimeEndVal}&uid=${
        this.uid
      }`
      console.log('condition', condition)
      if (type === 'score') {
        window.open(
          this.url +
            '/zkfz/zkolCourseScore/exportCourseCheckScoreModel' +
            condition
        )
      } else if (type === 'attendance') {
        window.open(
          this.url +
            '/zkfz/zkolCourseScore/exportClassAttendanceModel' +
            condition
        )
      }
    },
    //导入考核分
    uploadImportCourseCheckScore(res, file, fileList) {
      let formdata = new FormData()
      formdata.append('file', file.raw)
      // formdata.append('courseId', this.courseId)
      formdata.append('batchId', this.batchId)
      formdata.append('createBy', localStorage.getItem('uid') )
      api.importCourseCheckScoreWithAlbum(formdata).then((data) => {
        const { code, msg } = data.data
        if (code === 100000) {
          this.$message.success(msg)
          this.getCourseScore({
            page: this.pageObj.page,
            pageSize: this.pageObj.pageSize,
          })
          this.importScoreDialogVisible = false
        } else {
          this.$message.error(msg)
        }
      })
    },
    //导入课堂考勤
    uploadClassAttendance(res, file, fileList) {
      let formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('courseId', this.courseId)
      formdata.append('createBy', localStorage.getItem('uid') )
      api.importClassAttendance(formdata).then((data) => {
        const { code, msg } = data.data
        if (code === 100000) {
          this.$message.success(msg)
          this.getCourseScore({
            page: this.pageObj.page,
            pageSize: this.pageObj.pageSize,
          })
          this.importAttendanceDialogVisible = false
        } else {
          this.$message.error(msg)
        }
      })
    },
    failUpload(err) {
      this.$message.error(err)
    },

    showTipsDialog() {
      const isChecked = this.tableData.some((item) => item.checked)
      if (isChecked) {
        this.tipsDialogVisible = true
      } else {
        this.$confirm('没有选择学生,将发送给所有学生', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning',
          center: true,
        })
          .then(() => {
            this.tipsDialogVisible = true
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    sendTips() {
      this.$refs.tipsForm.validate(async (valid) => {
        if (valid) {
          console.log(this.tableData)
          let uids = ''
          let courseIds = ''
          let batchIds = ''
          this.tableData.forEach((item) => {
            if (item.checked) {
              uids += item.uid + ','
              courseIds += item.courseId + ','
              batchIds += item.batchId + ','
            }
          })
          const { code, msg } = (
            await api.superintendent({
              ...this.form,
              ...this.pageObj,
              orderAlbumId: this.orderAlbumId,
              fromUid: this.getUId,
              content: this.tipsForm.tipsTextarea,
              uids,
              courseIds,
              batchIds,
            })
          ).data
          if (code === 100000) {
            this.tipsDialogVisible = false
            this.$message.success(msg)
          } else {
            this.$message.error(msg)
          }
        }
      })
    },
    closeTipsDialog() {
      this.$refs.tipsForm.resetFields()
    },
    tipsTextareaChange(val) {
      if (this.tipsFormRadioList.includes(val)) {
        this.tipsForm.radio = val
      } else {
        this.tipsForm.radio = ''
      }
    },
    tipsFormRadioChange(val) {
      this.tipsForm.tipsTextarea = val
    },

    handleCheckAllChange(val) {
      this.isIndeterminate = false
      this.tableData.forEach((item) => {
        item.checked = val
      })
    },
    handleCheckOneChange(val) {
      let totalCount = this.tableData.length
      let someStatusCount = 0
      this.tableData.forEach((item) => {
        if (item.checked === val) {
          someStatusCount++
        }
      })
      this.checkAll = totalCount === someStatusCount ? val : !val
      this.isIndeterminate = someStatusCount > 0 && someStatusCount < totalCount
    },

    //综合考核情况对话框
    showGeneralTest(name, courseScoreId, uid) {
      this.generalTestFullName = name
      this.uid = uid
      this.getOverallCourseScoreInfo(courseScoreId)
    },
    //获取综合考核情况
    getOverallCourseScoreInfo(courseScoreId) {
      this.courseScoreId = courseScoreId
      api.getOverallCourseScoreInfo({ courseScoreId }).then((data) => {
        const { code, data: list, msg } = data.data
        if (code === 100000) {
          const {
            scoreStatus,
            moralScore,
            classAttendanceFinishInfo,
            homeworkScore,
            interactScore,
            orderOver,
          } = list
          const checkScore = {
            moralScore,
            classAttendanceFinishInfo,
            homeworkScore,
            interactScore,
          }
          for (let key in checkScore) {
            if (checkScore[key].indexOf('-') > -1) list[key] = ''
          }
          if (orderOver === false) {
            list.scoreStatus = '指标不全'
            this.isIndicatorIncomplete = true
          } else {
            if (scoreStatus === '指标不全') {
              this.isIndicatorIncomplete = true
            }
          }
          this.generalTestForm = list
          this.generalTestDialogVisible = true
        } else {
          this.$message.error(msg)
        }
      })
    },
    //修改综合考勤成绩
    saveCourseScore(id, type, val) {
      this.$confirm('确定要更改吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
        center: true,
      })
        .then(() => {
          if (val.includes('分')) val = val.replace('分', '')
          api.saveCourseScore({ id, [type]: val }).then((data) => {
            const { code, msg } = data.data
            if (code === 100000) {
              this.getCourseScore({
                page: this.pageObj.page,
                pageSize: this.pageObj.pageSize,
              })
              this.$message.success(msg)
            } else {
              this.$message.error(msg)
            }
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    closeGeneralTest() {
      this.generalTestForm = {}
      this.courseScoreId = ''
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getCourseScore(this.pageObj)
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getCourseScore(this.pageObj)
    },
    focusBorder() {
      this.borderFocus = true
      this.borderHover = false
    },
    blurBorder() {
      this.borderFocus = false
    },
    overBorder() {
      if (!this.borderFocus) {
        this.borderHover = true
      }
    },
    leaveBorder() {
      this.borderHover = false
    },
    showLearningOutcomeDetail(
      fullName,
      courseName,
      courseScoreId,
      uid,
      courseId,
      curIndex,
      isGeneral,
      batchId
    ) {
      this.curUserInfo = {
        fullName,
        courseName,
        courseScoreId,
        uid,
        courseId,
        curIndex,
        isGeneral,
        batchId,
      }
      this.learningOutcomeDetailVisible = true
    },
    closeLearningOutcomeDetail(courseScoreId) {
      this.learningOutcomeDetailVisible = false
      if (courseScoreId) {
        this.getOverallCourseScoreInfo(courseScoreId)
      }
    },
    prevIndex() {
      this.curUserInfo.curIndex--
    },
    nextIndex() {
      this.curUserInfo.curIndex++
    },
    async getFindUserByUid(){
      const { code, data } = (await api2.getFindUserByUid(this.getUId)).data
      if (code === 100000) {
        console.log('userType222',data)
        let type = data.type.split(',');
        let flag = false;
        if(type.length>0){
          type.forEach(item=>{
             if(item==='60'){
               flag = true;
             }
          })
        }
        if(flag){
          this.roleType = 60
        }
      }
    },
    // 获取用户信息
    getUserByUid() {
      api2.getUserByUid(this.getUId).then(({ data }) => {
        console.log('user')
        if (data.code === 100000) {
          this.userType = data.data.type
          console.log('this.userType111',this.userType)
        }
      })
    },
  },
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/classManagement.scss';
.tab {
  .tips_dialog {
    display: flex;
    align-items: center;
    .tips_dialog_title {
      width: 46px;
    }
  }
}

/deep/.border_focus {
  .el-input__inner {
    border-color: #409eff;
    outline: 0;
  }
}
/deep/.border_hover {
  .el-input__inner {
    border-color: #c0c4cc;
  }
}
.score_input {
  position: relative;
  .score_input_range {
    position: absolute;
    left: 47%;
    top: 0;
    line-height: 30px;
    z-index: 999;
  }
}
/deep/.minscore_input,
.maxscore_input {
  width: 50%;
}
/deep/.minscore_input {
  .el-input__inner {
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .el-input__inner::placeholder {
    text-align: center;
  }
}
/deep/.maxscore_input {
  .el-input__inner {
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .el-input__inner::placeholder {
    text-align: center;
  }
}
/deep/.score_status_time_dialog {
  .el-dialog__body,
  .el-dialog__footer {
    display: flex;
    justify-content: center;
  }
}
/deep/ .generalScoreTips .el-input__inner::placeholder {
  color: #d9001b;
}
/deep/.indicatorIncomplete {
  color: #d9001b;
  .el-input__inner {
    color: #d9001b;
  }
}
/deep/ .el-range-separator {
  width: 15% !important;
}
</style>